import React from "react";

const PartnerSection = ({ isMobile }) => {
  const handleConnectClick = () => {
    // Handle partner connection logic
    console.log("Partner connect clicked");
  };

  return (
    <div style={{ width: "100%", position: "relative", marginTop: isMobile ? "0" : "80px" }}>
      <img
        src={require("../../assets/landing_page_partner_with_us.png")}
        alt="Partner"
        style={{
          width: "100%",
          height: isMobile ? "250px" : "600px",
          objectFit: "cover",
          display: "block",
          animation: "fadeIn 2s ease-in-out",
        }}
      />

      <div
        style={{
          position: "absolute",
          ...(isMobile ? {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            width: "90%",
          } : {
            top: "35%",
            left: "10%",
            transform: "translateX(-10%)",
            textAlign: "left",
          }),
          color: "#fff",
        }}
      >
        <h2
          style={{
            fontSize: isMobile ? "18px" : "28px",
            fontWeight: "600",
            marginBottom: isMobile ? "12px" : "25px",
            textShadow: "1px 1px 4px rgba(0,0,0,0.3)",
          }}
        >
          Partner With Us
        </h2>

        <h4
          style={{
            fontSize: isMobile ? "12px" : "18px",
            fontWeight: "600",
            marginBottom: isMobile ? "16px" : "25px",
            textShadow: "1px 1px 4px rgba(0,0,0,0.3)",
            ...(isMobile ? {
              lineHeight: "1.4",
            } : {
              whiteSpace: "pre-line",
            }),
          }}
        >
          {isMobile 
            ? `Team up with us to make every event unforgettable and\nreach sports fans everywhere`
            : `Team up with us to make every event unforgettable and\nreach sports fans everywhere`
          }
        </h4>

        <button
          className={isMobile ? "mobile-partner-button" : "partner-button"}
          style={{
            backgroundColor: "transparent",
            color: "#fff",
            border: "2px solid #fff",
            fontSize: isMobile ? "12px" : "18px",
            fontWeight: "600",
            padding: isMobile ? "8px 16px" : "12px 24px",
            borderRadius: "50px",
            display: "flex",
            alignItems: "center",
            gap: isMobile ? "0" : "10px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            ...(isMobile ? {
              margin: "0 auto",
            } : {})
          }}
          onClick={handleConnectClick}
        >
          Let's Connect
        </button>
      </div>
    </div>
  );
};

export default PartnerSection;